import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { alertActions, diaryActions } from '_actions';
import {
    PatientCareCenterButton,
    LoadingIcon,
    StatusGood,
    SaveButton,
    CancelButton
} from '_components'
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import styles from './Details.module.css'

class DiaryTasksDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            resolveMsg: ''
        };
    }

    handleChange(event) {
        this.setState({ resolveMsg: event.target.value });
    }

    resolve() {
        if (this.state.resolveMsg.trim() !== '') {
            this.props.resolve(this.props.message.dlno, this.state.resolveMsg);
            this.setState({ resolveMsg: '' });
        } else {
            this.props.alertWarning('You must supply a message to resolve the item with.');
        }
    }

    render() {
        if (this.props.message)
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Diary Task: {this.props.message.patientName}</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />

                    <div className={styles.details_table}>
                        <div className={styles.details_cell} >
                            <div className={styles.labels}>
                                <div>Patient:</div>
                                <div>Category:</div>
                                <div>Initiated by:</div>
                            </div>
                            <div className={styles.data}>
                                <div>{this.props.message.patientName + ' (SYS#' + this.props.message.ptno + ')'}</div>
                                <div>{this.props.message.category}</div>
                                <div>{this.props.message.addUser}</div>
                            </div>
                        </div>
                        <div className={styles.button_wrapper}>
                            <div className={styles.button_div}>
                                <span className={styles.button}><StatusGood title='Resolve Item' onClick={() => this.props.toggleResolve()} /></span>
                                <span className={styles.button}><PatientCareCenterButton ptno={this.props.message.ptno} /></span>
                            </div>
                        </div>
                    </div>

                    {this.props.resolveVisible &&
                        <div className={styles.resolve_wrapper}>
                            <div className={styles.resolve_header}>Resolution</div>
                            <div className={styles.resolve_body} >
                                <div className={styles.resolve_text_area_wrapper} >
                                    <textarea maxLength={3000} autoFocus name="resolveMsg" type="text" className={styles.resolve_text_area} rows="4" value={this.state.resolveMsg} onChange={e => this.handleChange(e)} />
                                </div>
                                <div className={styles.resolve_buttons_wrapper} >
                                    <div className={styles.resolve_buttons_block} >
                                        <span className={styles.button} ><SaveButton onClick={() => this.resolve()} /></span>
                                        <span className={styles.button} ><CancelButton onClick={() => this.props.toggleResolve()} /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <div className={styles.wrapper}>
                        <div className={styles.message_wrapper} >
                            <div className={styles.message_content} >{this.props.message.message}</div>
                        </div>
                    </div>


                </div>
            );
        else
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Diary Task</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />
                    {this.props.loading === true ?
                        <LoadingIcon size="small" />
                        : <div className={styles.italic}>No Message Selected</div>
                    }
                </div>
            );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleResolve: bindActionCreators(diaryActions.toggleResolve, dispatch),
        resolve: bindActionCreators(diaryActions.resolve, dispatch),
        alertWarning: bindActionCreators(alertActions.warningMsg, dispatch)
    };
}

function mapStateToProps(state) {
    let message = state.entities.mcDiaryItems[state.ui.mcDiaryItems.selectedMessage];

    return {
        message,
        loading: state.ui.mcDiaryItems.loading,
        resolveVisible: state.ui.mcDiaryItems.resolveVisible
    };
}


const connectedDiaryTasksDetails = connect(mapStateToProps, mapDispatchToProps)(DiaryTasksDetails);
export { connectedDiaryTasksDetails as DiaryTasksDetails };
